// errori.ts — l'unico tipo di errore con cui il motore delle clip rifiuta le promesse (mai eccezioni generiche).

export type CodiceErroreClip = "non_supportato" | "nessuna_risata" | "annullata" | "memoria" | "codifica";

export class ErroreClip extends Error {
  readonly codice: CodiceErroreClip;
  constructor(codice: CodiceErroreClip, messaggio: string, causa?: unknown) {
    super(messaggio, causa === undefined ? undefined : { cause: causa });
    this.name = "ErroreClip";
    this.codice = codice;
  }
}

/** Trasforma qualsiasi errore in un ErroreClip (quelli già giusti passano così come sono). */
export function comeErroreClip(e: unknown, codice: CodiceErroreClip, messaggio: string): ErroreClip {
  if (e instanceof ErroreClip) return e;
  if (e instanceof DOMException && e.name === "AbortError") return new ErroreClip("annullata", "Montaggio annullato.", e);
  if (e instanceof DOMException && e.name === "QuotaExceededError") return new ErroreClip("memoria", "Memoria insufficiente per la clip.", e);
  if (e instanceof RangeError) return new ErroreClip("memoria", "Memoria insufficiente per la clip.", e);
  return new ErroreClip(codice, messaggio, e);
}
